import React, { useEffect, useRef, useState } from "react";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useSelector } from "react-redux";
import services from "utils/services";
import dayjs, { Dayjs } from "dayjs";

import Select from "shared/Select/Select";
import { Shift } from "data/data";
// import { saveFilters } from "redux/reducers/auth";
import { avatarColors, MONTH_DISPLAY } from "contains/contants";

import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import customParseFormat from "dayjs/plugin/customParseFormat"; // ES 2015
import weekOfYear from "dayjs/plugin/weekOfYear";
import updateLocale from "dayjs/plugin/updateLocale";

import "dayjs/locale/fr";

import { CheckIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import { useAuth } from "provider/useAuth";
import ModalCongesRecup from "components/ModalCongesRecup";
dayjs.extend(isSameOrBefore);
dayjs.extend(customParseFormat);
dayjs.extend(weekOfYear);
dayjs.locale("fr");
dayjs.extend(updateLocale);

dayjs.updateLocale("fr", {
	weekStart: 1,
});

function Bulletins() {
	const authContext = useAuth();

	const today = useRef(dayjs().startOf("month"));

	const [planning, setPlanning] = useState<any>([]);
	const [employee, setEmployee] = useState<any>(null);
	const [shifts, setShifts] = useState<Shift[]>([]);
	const [selectedMonth, setSelectedMonth] = useState(today.current.month());
	const [selectedYear, setSelectedYear] = useState(today.current.year());
	const [dayList, setDayList] = useState<any>([]);
	const [yearList, setYearList] = useState<any>([]);
	// const [monthList, setMonthList] = useState<any>([]);
	const [documentList, setDocumentList] = useState<any>([]);

	const [showModalCongesRecup, setShowModalCongesRecup] = useState(false);

	useEffect(() => {
		getDocuments();
	}, []);

	useEffect(() => {
		const monthList = [];
		const years = [];
		const currentDay = dayjs();

		for (let y = 2025; y <= currentDay.year(); y++) {
			years.push(y);
		}

		let firstMonth = currentDay.set("year", selectedYear).set("month", 0);

		const lastMonthNum =
			currentDay.year() == selectedYear
				? currentDay.date() > 15
					? currentDay.get("month")
					: currentDay.get("month") - 1
				: currentDay.get("month");
		setSelectedMonth(lastMonthNum);
		for (let m = 0; m <= lastMonthNum; m++) {
			monthList.push({
				value: firstMonth.get("month"),
				label: firstMonth.format("MMMM"),
			});
			firstMonth = firstMonth.add(1, "month");
		}

		setYearList(years);
		// setMonthList(monthList);
	}, [selectedMonth, setSelectedYear]);

	const getDocuments = () => {
		services.getDocuments(
			{ employee: authContext.user._id, year: selectedYear },
			(success) => {
				setDocumentList(success.documents);
			},
			(error) => {}
		);
	};


	// useEffect(() => {
	// 	if (displayType == MONTH_DISPLAY.value) {
	// 		today.current = today.current.startOf("month");
	// 	} else {
	// 		today.current = dayjs();
	// 	}

	// 	onChangePeriod();
	// }, [displayType]);
	// useEffect(() => {
	// 	onChangePeriod();
	// }, [displayDate]);

	// useEffect(() => {
	// 	getPlanning(dateFrom.format("YYYY-MM-DD"), dateTo.format("YYYY-MM-DD"));
	// }, [dateFrom, dateTo]);

	const download = async (doc: any) => {
		services.downloadDocument(
			{ id: doc._id },
			async (response, headers) => {
				// Récupérer le nom du fichier depuis les headers

				const contentDisposition = headers["content-disposition"];
				let filename = "document.pdf";

				if (contentDisposition) {
					const match = contentDisposition.match(
						/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
					);
					if (match && match[1]) {
						filename = match[1].replace(/['"]/g, "");
					}
				}

				// Créer un lien de téléchargement// Vérifier que response.data est bien un Blob
				let blob;
				if (response instanceof Blob) {
					blob = response;
				} else {
					// Si ce n'est pas un Blob, le créer
					blob = new Blob([response], {
						type:
							response.headers["content-type"] || "application/octet-stream",
					});
				}
				const downloadUrl = window.URL.createObjectURL(blob);
				const link = document.createElement("a");
				link.href = downloadUrl;
				link.download = filename;

				// Déclencher le téléchargement
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);

				// Nettoyer l'URL d'objet
				window.URL.revokeObjectURL(downloadUrl);
			},
			(error) => {
				alert("Une erreur est survenu");
			}
		);
	};

	const renderDocuments = () => {
		return documentList.map((doc: any, index: number) => {
			const docDate = dayjs()
				.set("year", doc.documentYear)
				.set("month", doc.documentMonth);
			return (
				<div key={index}>
					{index > 0 && (
						<hr className="mt-3 border-slate-200 dark:border-slate-700 "></hr>
					)}
					<div
						className={`relative flex flex-row items-center justify-between pt-3 sm:pt-3 last:pb-0 first:pt-0 w-[100%] `}
					>
						<div className={`flex-1`}>
							Bulletin{" "}
							<span className="capitalize">{docDate.format("MMMM YYYY")}</span>
						</div>
						<div className="flex-1 flex justify-end">
							<ButtonPrimary
								onClick={() => download(doc)}
								sizeClass="py-2 px-4"
								className="py-2 w-[50%]"
							>
								Télécharger
							</ButtonPrimary>
						</div>
					</div>
				</div>
			);
		});
	};

	return (
		<div className="nc-EmployeePlanning relative overflow-hidden">
			{/* SECTION HERO */}
			{/* <SectionHero2 /> */}

			<div className="container relative my-8 px-14">
				<div>
					<h2 className="text-2xl md:text-3xl font-semibold">Bulletins</h2>
					<div className="flex flex-row gap-3 mt-2">
						{/* <Select
							className="!w-[150px] rounded-lg border-slate-500"
							onChange={({ target }) => {
								setSelectedMonth(parseInt(target.value));
							}}
							value={selectedMonth}
						>
							<option></option>
							{monthList.map((m: any, i: number) => (
								<option value={m.value}>{m.label}</option>
							))}
						</Select> */}
						{yearList.length > 0 && (
							<Select
								className="!w-[100px] rounded-lg border-slate-500"
								onChange={({ target }) => {
									setSelectedYear(parseInt(target.value));
								}}
								value={selectedYear}
							>
								{yearList.map((y: number, i: number) => {
									return (
										<option value={y} key={i}>
											{y}
										</option>
									);
								})}
							</Select>
						)}
						<ButtonPrimary
							className="rounded-lg"
							onClick={() => getDocuments()}
						>
							<CheckIcon className="h-5 w-5" />
						</ButtonPrimary>
					</div>
				</div>
				<div className=" relative mb-3">
					<BackgroundSection className="bg-neutral-50/80 dark:bg-black/20" />
					<div className="flex mt-2 justify-end items-start gap-2"></div>
					<div className="flex flex-col py-2 items-center relative">
						<div className="w-[100%]">
							<div className="flex flex-col gap-3 items-center">
								<div className="w-[100%] border-2 border-slate-500 rounded-lg min-h-80 py-5 px-6">
									{/* <div className="flex flex-row items-center justify-between gap-3 py-3 px-3 bg-white rounded-t-lg border-dashed border-slate-500 border-b-4 rounded-b-none"> */}
										{/* <span className="font-semibold text-lg">
											{today.current.format("MMMM YYYY").toUpperCase()}
										</span> */}
									{/* </div> */}
									<div className="flex flex-col">
										{/* <div className="flex flex-row border-b-2">
											<div className="w-[10%] border-r"></div>
											<div className="flex flex-row w-[90%] items-center">
												{renderHoursHeader()}
											</div>
										</div> */}
										{renderDocuments()}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Bulletins;
